var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"errors-container",class:[_vm.classstyle]},[_vm._v("\n    "+_vm._s(_vm.getError)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }